// helpers.ts — Pure utility functions for N202 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Record type label mapping */
export const recordTypeLabel = (v: number): string => {
  switch (v) {
    case 1: return '待確認';
    case 2: return '採購';
    case 3: return '業務+採購';
    default: return '未知';
  }
};

/** File type label mapping */
export const fileTypeLabel = (v: number): string => {
  switch (v) {
    case 1: return 'Word';
    case 2: return 'Excel';
    case 3: return 'PPT';
    case 4: return 'HTML';
    case 5: return 'PDF';
    default: return '未知';
  }
};

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, _mode: string): boolean => {
  if (!isEditing) return true;
  const alwaysReadonly = new Set([
    'fn110_01', 'fn110_132', 'fn110_48', 'fn110_58', 'fn110_68',
    'fn110_35', 'fn110_36', 'fn110_37',
  ]);
  if (alwaysReadonly.has(key)) return true;
  return false;
};
